import React from 'react';
import {
  Col, Row, Label, Modal, ModalBody,
} from 'reactstrap';
import PropTypes from 'prop-types';
import PrimaryButton from '../PrimaryButton/PrimaryButton';
import SecondaryButton from '../SecondaryButton/SecondaryButton';
import { useAppContext } from '../../state/GlobalState';

const RedirectCheckModal = ({
  isOpen,
  onRedirectHandler,
  onCloseHandler,
  loadingFeedback,
  onCompleteShipment,
}) => {
  if (!isOpen) {
    return null;
  }
  const {
    virtualTerminal, 
    isDPTerminal,
    tripType,
  } = useAppContext();

  const redirectMessageVirtual = isDPTerminal ? 'Would you like to complete the delivery ?' : 'Would you like to redirect or complete this delivery docket ?';
  const redirectMessageNonVirtual = 'Would you like to redirect this delivery docket?';
  const redirectBtnText = isDPTerminal ? 'Enter another delivery' : 'Yes, redirect it';
  const completeBtnText = isDPTerminal ? 'Complete the delivery' : 'Yes, complete the delivery';
  
  return (
    <Modal isOpen={isOpen} className="redirect-check-modal" data-testid="redirect-check-modal" centered>
      <ModalBody>
        <Row className="pt-12 pb-12">
          <Col xs={{ size: 10, offset: 1 }}>
            <Row>
              <Col xs={{ size: 10, offset: 1 }}>
                <Label className="mb-8 roboto font-30 lightweight text-center redirect-check-modal-title" data-testid="redirect-check-modal-title">
                  {virtualTerminal || isDPTerminal ? redirectMessageVirtual : redirectMessageNonVirtual}
                </Label>
              </Col>
            </Row>

            {(virtualTerminal || (isDPTerminal && tripType === 'O')) && (
            <>
              <Row>
                <Col className="pl-5">
                  <PrimaryButton label={redirectBtnText} onClick={onRedirectHandler} data-testid="redirect-btn" />
                </Col>
                <Col className="pl-0">
                  <PrimaryButton label={completeBtnText} onClick={onCompleteShipment} data-testid="redirect-btn" />
                </Col>

              </Row>
              <Row className="mt-5">
                <Col className="pl-5">
                  <SecondaryButton label="Cancel" onClick={onCloseHandler} data-testid="cancel-btn" />
                </Col>
              </Row>
            </>)}
            {!virtualTerminal && !(isDPTerminal && tripType === 'O') &&
            <>
              <Row>
                <Col className="pl-0">
                  <PrimaryButton label={redirectBtnText} onClick={onRedirectHandler} data-testid="redirect-btn" />
                </Col>

                <Col className="pr-0">
                  <SecondaryButton label="Cancel" onClick={onCloseHandler} data-testid="cancel-btn" />
                </Col>
              </Row>
            </>}
          </Col>
        </Row>
        <Row className="justify-content-center mb-2">
          <Label className="univers font-14 text-center">{loadingFeedback}</Label>
        </Row>
      </ModalBody>
    </Modal>
  );
};

RedirectCheckModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRedirectHandler: PropTypes.func.isRequired,
  onCloseHandler: PropTypes.func.isRequired,
  loadingFeedback: PropTypes.string,
};

export default RedirectCheckModal;
